<template>
  <div>
    <JumpHeader />
    <div
      class="live-detail"
      v-if="isNormal"
      :style="{ 'background-color': hscreenV == 2 ? 'black' : '' }"
    >
      <div v-if="hscreenV == 1">
        <div class="live-win">
          <video
            v-if="!isFuture"
            id="videoPlayer"
            class="video-class"
            ref="videoRef"
            playsinline
            webkit-playsinline
            controls
          ></video>
          <img class="pic-class" v-else :src="detail.pictureUrl" alt="" />
        </div>
        <div class="live-title">
          <span
            :class="[
              'tag',
              detail.playStatus == 2 && 'tag-playback',
              detail.playStatus == 3 && 'tag-future',
            ]"
            >{{ detail.playStatus == 1 ? "直播" : detail.playStatus == 2 ? "回放" : "预告" }}</span
          >
          {{ detail.name }}
        </div>
        <div class="content-wrapper">
          <van-tabs v-model="tabsActive" line-width="80px">
            <van-tab title="图文">
              <div class="load-content">
                <div v-html="detail.richText"></div>
              </div>
            </van-tab>
            <van-tab title="评论">
              <!-- 评论 -->
              <div class="load-content">
                <van-list
                  v-model="commentLoad.loading"
                  :finished="commentLoad.finished"
                  finished-text="已经到底了"
                  @load="commentOnLoad"
                  class="comment-list"
                >
                  <div class="comment-item" v-for="item in commentList" :key="item.id">
                    <span class="comment-content">
                      <van-image
                        width="25px"
                        height="25px"
                        fit="contain"
                        class="avatar"
                        round
                        :src="item.userPersonalImage"
                      />
                      <span class="nickname"
                        >{{ item.userNickname ? item.userNickname : "游客" }}：</span
                      >
                      <span class="content">{{ item.content }}</span>
                    </span>
                  </div>
                </van-list>
              </div>
            </van-tab>
            <van-tab title="简介">
              <div class="tabs-content">
                <span style="font-size: 16px">{{ detail.intro }}</span>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <div v-if="hscreenV == 2">
        <div class="live-win" style="height: 95vh; position: relative; overflow: hidden">
          <video
            v-if="!isFuture"
            id="videoPlayer"
            class="video-class"
            ref="videoRef"
            playsinline
            webkit-playsinline
            controls
            style="object-fit: contain"
          ></video>
          <img class="pic-class" v-else :src="detail.pictureUrl" alt="" />
          <div class="s-screen">
            {{ detail.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="placeholder" v-else>
      <van-empty image="error" description="直播已下架" />
    </div>
    <div class="gen-wrapper" @click="showPopup = true" v-if="detail.isCertificate">
      <div>生成</div>
      <div>证书</div>
    </div>

    <van-overlay :show="showPopup" @click="showPopup = false">
      <div class="wrapper">
        <div class="input-wrapper" v-if="!hadGenPic" @click.stop>
          <div class="input-item">
            <van-field
              v-model="name"
              :border="false"
              class="field-class"
              label="姓名"
              placeholder="请输入姓名"
            />
          </div>
          <div class="input-item">
            <van-field
              v-model="schoolName"
              :border="false"
              class="field-class"
              label="学校"
              placeholder="请输入学校"
            />
          </div>
          <van-button type="info" size="large" round @click="handleClickGenPic"
            >生成证书</van-button
          >
        </div>
        <div class="pic-wrapper" v-else @click.stop>
          <img class="gen-pic-class" :src="genPicUrl" alt="" />
          <div class="info-tip">
            <van-icon name="warning" color="#E6A23C" size="30px" />
            <div>{{ checkMobile() ? "长按保存图片" : "右键图片点击复制" }}</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showLoading">
      <div class="loading-wrapper">
        <van-loading size="40px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Hls from "hls.js";
import wxSdk from "@/http/wxApi.js";
import { getMobilsInfo } from "@/utils";
import { getChannelLiveDetail, queryAllComments, clickRecord, genPic } from "@/http/api";
import ZMYDataCollection from "@/utils/zmy.js";
import JumpHeader from "@/components/Base/JumpHeader";

export default {
  name: "LiveDetail",
  components: {
    JumpHeader,
  },
  data() {
    return {
      id: null,
      hls: null,
      detail: {},
      tabsActive: 0,
      commentList: [],
      pageNum: 1,
      isFuture: false,
      commentLoad: {
        loading: false,
        finished: false,
      },
      isNormal: true,
      showPopup: false,
      name: "",
      schoolName: "",
      showLoading: false,
      hadGenPic: false,
      genPicUrl: "",
      hscreenV: 1,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail();
    this.queryCommentData();
    this.recordData();
    ZMYDataCollection.init({
      tenant_code: "prod-gzgb-6b45b19f05d3b092013fd6",
      key: "wJT7EOgGmpHClezJ2qgb1nE60RgVUnrX",
      domain: "rmapi.nfzmy.com",
      debug: "false",
    });
  },
  methods: {
    async getDetail() {
      const { data } = await getChannelLiveDetail({
        id: this.id,
      });
      this.hscreenV = data.hscreenV;
      this.detail = data;

      if (this.detail.effect == 8 && this.detail.isHide == 0) {
        // 已下架
        this.isNormal = false;
        this.wxShare();
        return;
      }
      ZMYDataCollection.openActivityH5({ activity_id: this.id, platform: "Mobile" });
      console.log(data);
      this.wxShare();
      if (this.detail.playStatus == 1) {
        // 直播
        this.getStream(this.detail.liveStream, true, this.detail.pictureUrl);
      } else if (this.detail.playStatus == 2) {
        // 回放
        this.getStream(this.detail.playBackUrl, true, this.detail.pictureUrl);
      } else {
        // 预告
        this.isFuture = true;
      }
      document.title = data.name ? data.name : "花城+";
    },
    async queryCommentData() {
      this.commentLoad.loading = true;
      const { data } = await queryAllComments({
        operateId: this.id,
        operateType: 5,
        pageNum: this.pageNum,
        pageSize: 10,
      });
      this.commentLoad.loading = false;
      this.commentList = [...this.commentList, ...data.records];
      if (this.pageNum >= data.pages) {
        this.commentLoad.finished = true;
      }
    },
    handleClickGenPic() {
      this.showLoading = true;
      genPic({
        name: this.name,
        schoolName: this.schoolName,
        operateId: this.detail.id,
        operateType: 5,
      }).then((res) => {
        console.log(res);
        this.showLoading = false;
        if (res) {
          this.hadGenPic = true;
          this.genPicUrl = res.url;
        }
      });
    },
    async recordData() {
      await clickRecord({
        deviceId: "1",
        operateId: this.id,
        operateType: 5,
        web: 1,
      });
    },
    commentOnLoad() {
      this.pageNum++;
      this.queryCommentData();
    },
    getStream(source, status, pictureUrl) {
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(source);
        this.hls.attachMedia(this.$refs.videoRef);
        this.$refs.videoRef.poster = pictureUrl;
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("加载成功");
          // if (status) {
          //   this.$refs.videoRef.play();
          // } else {
          //   this.$refs.videoRef.pause();
          // }
        });
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          console.log("error");
          console.log(event, data);
        });
      } else if (this.$refs.videoRef.canPlayType("application/x-mpegURL")) {
        console.log("dddddddddddddddddddd");
        this.$refs.videoRef.src = source;
        this.$refs.videoRef.poster = pictureUrl;
        this.$refs.videoRef.addEventListener("loadedmetadata", () => {
          // if (status) {
          //   this.$refs.videoRef.play();
          // } else {
          //   this.$refs.videoRef.pause();
          // }
        });
      }
    },
    checkMobile() {
      let result = true;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ) {
        // 当前设备是手机
        result = true;
      } else {
        // 当前设备不是手机
        result = false;
      }
      return result;
    },
    wxShare() {
      const _detail = this.detail;
      wxSdk.getJSSDK({
        title: _detail.name,
        desc: _detail.intro,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/liveDetail?id=${_detail.id}`,
        img: `${process.env.VUE_APP_SHARE_URL}/filedata/default/hcplusIcon.jpg`,
        operateId: this.id,
        operateType: 5,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

// video::-webkit-media-controls-timeline {
//   background: linear-gradient(to right, red, blue); /* 自定义背景渐变 */
// }

// video::-webkit-media-controls-time-remaining-display,
// video::-webkit-media-controls-current-time-display {
//   display: none; /* 隐藏时间显示 */
//   transform: translateY(-10%);
// }

.placeholder {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.live-detail {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.live-win {
  width: 100%;
  height: calc(100vw * 9 / 16);
  background: #111;

  .s-screen {
    display: flex;
    font-size: 16px;
    height: 46px;
    box-sizing: border-box;
    padding: 0 23px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    // -webkit-line-clamp: 2; //行数
    // line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
    position: absolute;
    bottom: 15%;
    left: 3px;
    z-index: 999;
    color: rgb(245, 245, 245);
    font-weight: bold;
    line-height: 23px;
  }

  .video-class {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .pic-class {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.live-title {
  display: flex;
  font-size: 16px;
  height: 55px;
  box-sizing: border-box;
  padding: 10px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden; //溢出内容隐藏
  text-overflow: ellipsis; //文本溢出部分用省略号表示
  display: -webkit-box; //特别显示模式
  -webkit-line-clamp: 2; //行数
  line-clamp: 2;
  -webkit-box-orient: vertical; //盒子中内容竖直排列

  .tag {
    display: inline-block;
    padding: 3px 10px;
    font-size: 10px;
    color: #fff;
    background: linear-gradient(139deg, #f75a90 1%, #e92c13 100%);
    border-radius: 0 10px;
    margin-right: 3px;
  }

  .tag-playback {
    background: rgba(0, 0, 0, 0.65);
  }

  .tag-future {
    background: linear-gradient(136deg, #8583e7 0%, #7ea9f9 48%, #91e0ff 100%);
  }
}

.content-wrapper {
  width: 100%;
  height: 100%;
  flex: 1;
}

.tabs-content {
  box-sizing: border-box;
  padding: 10px;
}

.load-content {
  width: 100%;
  height: calc(100vh - 110px - 100vw * 9 / 16);
  box-sizing: border-box;
  padding: 0 10px;
  overflow: hidden;
  overflow-y: auto;

  .comment-item {
    margin: 10px 0;

    .comment-content {
      display: inline-block;
      padding: 3px 10px 6px 10px;
      border-radius: 8px;
      background-color: #eff0f8;
      font-size: 14px;

      .avatar {
        margin-right: 8px;
        transform: translateY(5px);
      }

      .nickname {
        vertical-align: middle;
      }

      .content {
        color: #000000a6;
        vertical-align: middle;
      }
    }
  }
}

.gen-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 100px;
  right: 10px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #409eff;
  box-shadow: 0 0 8px #999;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .input-wrapper {
    width: 350px;
    height: 220px;
    border-radius: 8px !important;
    background: #fff;
    box-sizing: border-box;
    padding: 10px;
  }

  .field-class {
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    background: #eee;
  }

  .pic-wrapper {
    width: 350px;
    height: 250px;
    border-radius: 8px !important;
    background: #fff;
    box-sizing: border-box;
    padding: 10px;

    .gen-pic-class {
      width: 100%;
      height: 200px;
    }

    .info-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
    }
  }
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

@media screen and (min-width: 768px) {
  .live-win {
    width: 100%;
    height: 432px;
  }

  .load-content {
    width: 100%;
    height: calc(100vh - 542px);
    box-sizing: border-box;
    padding: 0 10px;
    overflow: hidden;
    overflow-y: auto;
  }
  .gen-wrapper {
    right: calc(50vw - 374px);
  }
  .input-wrapper {
    width: 700px !important;
    height: 440px !important;
    padding: 20px !important;
  }
  .pic-wrapper {
    width: 700px !important;
    height: 500px !important;

    .gen-pic-class {
      width: 100%;
      height: 400px !important;
    }
  }

  .field-class {
    margin-bottom: 30px !important;
  }
}
</style>
